import * as React from 'react';
//import Image1 from '../../../components/Links/Entsiegelung_Deutschland.JPG';
//import Image2 from '../../../components/Links/Holzdeck mit Fugenfarn.jpg';
//import Image3 from '../../../components/Links/Strassenbegleitgruen Fulpmes.jpg';

import Image1 from '../../../images/service/Beratung1.jpg';
import Image2 from '../../../images/service/Beratung2.jpg';
import Image3 from '../../../images/service/Beratung3.jpg';

import Grid from '@mui/material/Grid';


export default function PicturesGem() {

  return (

    <div>

      <Grid container spacing={0}>

        <Grid item xs={12} md={12} lg={4} className='photogallery' >

          <img src={Image1} className='gallery' alt="gallery"/>

        </Grid>

        <Grid item xs={12} md={12} lg={4} className='photogallery' >

          <img src={Image2} className='gallery' alt="gallery" />

        </Grid>

        <Grid item xs={12} md={12} lg={4} className='photogallery'>

          <img src={Image3} className='gallery' alt="gallery" />

        </Grid>

      </Grid>
    </div>

  );
}
